export default __webpack_public_path__ + "static/media/img-mission.45463334.jpg";